import { useEffect, useState } from 'react';
import { copyToClipboard } from 'utils/common';

export function useCopyToClipboard() {
  let [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      let timer = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  function copy(text) {
    if (!copied) {
      copyToClipboard(text);
      setCopied(true);
    }
  }

  return [copy, copied];
}
